import React from "react"
import { useLocation } from "react-router-dom/cjs/react-router-dom"
import TagsLayout from "../TagsLayout"
import ConnectionsLayout from "../ConnectionsLayout"
import QuickMessageLayout from "../QuickMessageLayout"
import QueueIntegrationLayout from "../QueueIntegrationLayout"
import FilesLayout from "../FilesLayout"
import QueueLayout from "../QueueLayout"
import UsersLayout from "../UsersLayout"
import ContatcsLayout from "../ContactsLayout"
import CampaignsLayout from "../CampaignsLayout"
import AnnouncementsLayout from "../AnnouncementsLayout"
import SchedulesLayout from "../SchedulesLayout"

const PathUtils = () => {
  const location = useLocation()

  return (
    <>
      {location.pathname.includes("contacts") && <ContatcsLayout />}
      {location.pathname.includes("situacoes") && <TagsLayout />}
      {location.pathname.includes("connections") && <ConnectionsLayout />}
      {location.pathname.includes("schedules") && <SchedulesLayout />}
      {location.pathname.includes("quick-messages") && <QuickMessageLayout />}
      {location.pathname.includes("queue-integration") && <QueueIntegrationLayout />}
      {location.pathname.includes("files") && <FilesLayout />}
      {location.pathname.includes("queues") && <QueueLayout />}
      {location.pathname.includes("users") && <UsersLayout />}
      {location.pathname.includes("campaigns") && <CampaignsLayout />}
      {location.pathname.includes("announcements") && <AnnouncementsLayout />}
    </>
  )
}

export default PathUtils
